import { Injectable, inject, signal, computed } from '@angular/core';
import { CmsApiService } from './api/cms-api.service';
import { combineLatest } from 'rxjs';
import { CmsContentMapperService } from './cms-content-mapper.service';
import { map, switchMap } from 'rxjs/operators';
import { LanguageService } from './language.service';
import { UserService } from './user/user.service';
import { ArrayService } from 'ngx-unificator/services';
import { PaymentType } from '../types/banking-type';

@Injectable({
  providedIn: 'root',
})
export class BankingService {

  private _api = inject(CmsApiService);
  private _mapper = inject(CmsContentMapperService);
  private _languageService = inject(LanguageService);
  private _array = inject(ArrayService);
  private _user = inject(UserService);

  public _payments = signal<PaymentType>({
    deposit: [],
    withdraw: [],
  });

  public depositPayments = computed(() => this._payments().deposit);
  public withdrawPayments = computed(() => this._payments().withdraw);
  public mergedPayments = computed(() => this._array.uniqueBy('id',
    [...this._payments().deposit, ...this._payments().withdraw]));

  public fetchPayments() {
    this._languageService.langChange$.pipe(
      switchMap(() => combineLatest([
        this.getPaymentMethodsByType('deposit', Number(this._user.auth)),
        this.getPaymentMethodsByType('cashout', Number(this._user.auth)),
      ])),
    ).subscribe(([deposit, withdraw]) => {
      this._updatePaymentStateEntities({ deposit, withdraw });
    });
  }

  /**
   * Get payment methods from CMS by type
   */
  getPaymentMethodsByType(type: string, sort_auth_player: number) {
    return this._api.paymentList({ type, sort_auth_player }).pipe(
      map(response => this._mapper.mapCmsData(response.data, {
        id: 'id',
        slug: 'slug',
      })),
      map((list: any[]) => list.filter(e => e.id)),
      map((list: any[]) => list.map(item => {
        return {
          ...item,
          image: `/assets/svg/payments/fiat/color/${item.slug}.svg`,
        };
      })),
    );
  }

  private _updatePaymentStateEntities(entity: Partial<PaymentType>) {
    this._payments.update(state => {
      return {
        ...state,
        ...entity,
      };
    });
  }
}
